import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    safet_alarm_0_text: {
      id: 'safet_alarm_0_text',
      defaultMessage: "Rozpoznany został mikro wyciek (np. spłuczka WC). Dopuszczalny przepływ został przekroczony",
      description: '',
    },
    safet_alarm_1_text: {
      id: 'safet_alarm_1_text',
      defaultMessage: "Zawór odcinający zablokowany. Możliwe zanieczyszczenie lub defekt silnika. Ochrona przed przeciekami ograniczona",
      description: '',
    },
    safet_alarm_2_text: {
      id: 'safet_alarm_2_text',
      defaultMessage: "Turbinka przepływomierza zablokowana. Możliwe zanieczyszczenie lub uszkodzenie turbiny. Ochrona przed przeciekami ograniczona",
      description: '',
    },
    safet_alarm_3_text: {
      id: 'safet_alarm_3_text',
      defaultMessage: "Rozpoznany został przeciek objętościowy. Dopuszczalny pobór wody został przekroczony.",
      description: '',
    },
    safet_alarm_4_text: {
      id: 'safet_alarm_4_text',
      defaultMessage: "Rozpoznany został zbyt duży przepływ chwilowy (>3500l/h), np. pęknięcie rury",
      description: '',
    },
    safet_alarm_5_text: {
      id: 'safet_alarm_5_text',
      defaultMessage: "Rozpoznany został przeciek podczas ochrony urlopowej. Dopuszczalny pobór wody został przekroczony",
      description: '',
    },
    safet_alarm_6_text: {
      id: 'safet_alarm_6_text',
      defaultMessage: "Rozpoznany został przeciek przez czujnik podłogowy",
      description: '',
    },
    safet_alarm_7_text: {
      id: 'safet_alarm_7_text',
      defaultMessage: "Rozpoznany został przeciek na wejściu IN2.",
      description: '',
    },
    safet_alarm_8_text: {
      id: 'safet_alarm_8_text',
      defaultMessage: "Wykryto przeciek 48h np. spłuczka WC",
      description: '',
    },
    safet_alarm_9_text: {
      id: 'safet_alarm_9_text',
      defaultMessage: "Wyciek związany z przekroczeniem czasu poboru wody. Czas poboru wody przekroczył dopuszczalne wartości.",
      description: '',
    },
    problems_dictionary_0_sup: {
      id: 'problems_dictionary_0_sup',
      defaultMessage: "No error",
      description: '',
    },
    problems_dictionary_1_sup: {
      id: 'problems_dictionary_1_sup',
      defaultMessage: "System pressure too low",
      description: '',
    },
    problems_dictionary_2_sup: {
      id: 'problems_dictionary_2_sup',
      defaultMessage: "System pressure too high",
      description: '',
    },
    problems_dictionary_3_sup: {
      id: 'problems_dictionary_3_sup',
      defaultMessage: "Too low water temperature",
      description: '',
    },
    problems_dictionary_4_sup: {
      id: 'problems_dictionary_4_sup',
      defaultMessage: "Too high water temperature",
      description: '',
    },
    problems_dictionary_5_sup: {
      id: 'problems_dictionary_5_sup',
      defaultMessage: "Input flow blocked",
      description: '',
    },
    problems_dictionary_6_sup: {
      id: 'problems_dictionary_6_sup',
      defaultMessage: "Low level vessel repeatedly",
      description: '',
    },
    problems_dictionary_7_sup: {
      id: 'problems_dictionary_7_sup',
      defaultMessage: "Low level vessel",
      description: '',
    },
    problems_dictionary_8_sup: {
      id: 'problems_dictionary_8_sup',
      defaultMessage: "Main pump overheated",
      description: '',
    },
    problems_dictionary_9_sup: {
      id: 'problems_dictionary_9_sup',
      defaultMessage: "Main pump overload",
      description: '',
    },
    problems_dictionary_10_sup: {
      id: 'problems_dictionary_10_sup',
      defaultMessage: "Refill flow too low",
      description: '',
    },
    problems_dictionary_11_sup: {
      id: 'problems_dictionary_11_sup',
      defaultMessage: "Refill valve open",
      description: '',
    },
    problems_dictionary_12_sup: {
      id: 'problems_dictionary_12_sup',
      defaultMessage: "Unknown errror",
      description: '',
    },
    problems_dictionary_13_sup: {
      id: 'problems_dictionary_13_sup',
      defaultMessage: "Refill: too often",
      description: '',
    },
    problems_dictionary_14_sup: {
      id: 'problems_dictionary_14_sup',
      defaultMessage: "Refill: too long",
      description: '',
    },
    problems_dictionary_15_sup: {
      id: 'problems_dictionary_15_sup',
      defaultMessage: "Refill: too much",
      description: '',
    },
    problems_dictionary_16_sup: {
      id: 'problems_dictionary_16_sup',
      defaultMessage: "Unknown errror",
      description: '',
    },
    problems_dictionary_17_sup: {
      id: 'problems_dictionary_17_sup',
      defaultMessage: "Wrong phase order",
      description: '',
    },
    problems_dictionary_18_sup: {
      id: 'problems_dictionary_18_sup',
      defaultMessage: "Too big output pressure",
      description: '',
    },
    problems_dictionary_19_sup: {
      id: 'problems_dictionary_19_sup',
      defaultMessage: "Pressure sensor fault",
      description: '',
    },
    problems_dictionary_20_sup: {
      id: 'problems_dictionary_20_sup',
      defaultMessage: "Fuse 2 broken",
      description: '',
    },
    problems_dictionary_21_sup: {
      id: 'problems_dictionary_21_sup',
      defaultMessage: "Fuse 3 broken",
      description: '',
    },
    problems_dictionary_22_sup: {
      id: 'problems_dictionary_22_sup',
      defaultMessage: "Communication fault",
      description: '',
    },
    problems_dictionary_23_sup: {
      id: 'problems_dictionary_23_sup',
      defaultMessage: "Too low expansion vessel",
      description: '',
    },
    problems_dictionary_24_sup: {
      id: 'problems_dictionary_24_sup',
      defaultMessage: "Low level break tank",
      description: '',
    },
    problems_dictionary_25_sup: {
      id: 'problems_dictionary_25_sup',
      defaultMessage: "Pump error",
      description: '',
    },
    problems_dictionary_26_sup: {
      id: 'problems_dictionary_26_sup',
      defaultMessage: "Unknown error",
      description: '',
    },
    problems_dictionary_27_sup: {
      id: 'problems_dictionary_27_sup',
      defaultMessage: "Unknown error",
      description: '',
    },
    problems_dictionary_28_sup: {
      id: 'problems_dictionary_28_sup',
      defaultMessage: "Unknown error",
      description: '',
    },
    problems_dictionary_29_sup: {
      id: 'problems_dictionary_29_sup',
      defaultMessage: "Unknown error",
      description: '',
    },
    problems_dictionary_30_sup: {
      id: 'problems_dictionary_30_sup',
      defaultMessage: "Inlet blocked",
      description: '',
    },
    problems_dictionary_31_sup: {
      id: 'problems_dictionary_31_sup',
      defaultMessage: "Fill time too long",
      description: '',
    },
    problems_dictionary_32_sup: {
      id: 'problems_dictionary_32_sup',
      defaultMessage: "Pressure drop inlet too high",
      description: '',
    },
    problems_dictionary_33_sup: {
      id: 'problems_dictionary_33_sup',
      defaultMessage: "Pressure drop inlet too low",
      description: '',
    },
    problems_dictionary_34_sup: {
      id: 'problems_dictionary_34_sup',
      defaultMessage: "SmartSwitch broken",
      description: '',
    },
    problems_dictionary_35_sup: {
      id: 'problems_dictionary_35_sup',
      defaultMessage: "Solenoid valve does not close",
      description: '',
    },
    problems_dictionary_36_sup: {
      id: 'problems_dictionary_36_sup',
      defaultMessage: "Undesirable air intake",
      description: '',
    },
    problems_dictionary_37_sup: {
      id: 'problems_dictionary_37_sup',
      defaultMessage: "Incompressible system",
      description: '',
    },
    problems_dictionary_38_sup: {
      id: 'problems_dictionary_38_sup',
      defaultMessage: "Incompressible system",
      description: '',
    },
    softener_alarm_1_text: {
      id: 'softener_alarm_1_text',
      defaultMessage: "No salt during regeneration ",
      description: '',
    },
    softener_alarm_2_text: {
      id: 'softener_alarm_2_text',
      defaultMessage: "Too low water pressure",
      description: '',
    },
    softener_alarm_3_text: {
      id: 'softener_alarm_3_text',
      defaultMessage: "Too high water pressure",
      description: '',
    },
    softener_alarm_4_text: {
      id: 'softener_alarm_4_text',
      defaultMessage: "Pressure sensor failure",
      description: '',
    },
    softener_alarm_5_text: {
      id: 'softener_alarm_5_text',
      defaultMessage: "Valve mechanism failure",
      description: '',
    },
    softener_alarm_6_text: {
      id: 'softener_alarm_6_text',
      defaultMessage: "Too low water pressure during regeneration",
      description: '',
    },
    softener_alarm_7_text: {
      id: 'softener_alarm_7_text',
      defaultMessage: "Power break during regeneration",
      description: '',
    },
    softener_alarm_8_text: {
      id: 'softener_alarm_8_text',
      defaultMessage: "Radio valve communication problem",
      description: '',
    },
    softener_alarm_9_text: {
      id: 'softener_alarm_9_text',
      defaultMessage: "Time flow exceeded, leakage suspected",
      description: '',
    },
    softener_notifications_1_text: {
      id: 'softener_notifications_1_text',
      defaultMessage: "Low predicted the amount of salt",
      description: '',
    },
    softener_notifications_2_text: {
      id: 'softener_notifications_2_text',
      defaultMessage: "Water pressure under 1.5 bar",
      description: '',
    },
    softener_notifications_3_text: {
      id: 'softener_notifications_3_text',
      defaultMessage: "Upcoming service",
      description: '',
    },
    softener_notifications_4_text: {
      id: 'softener_notifications_4_text',
      defaultMessage: "Lack of water, pressure at 0 bar for more than 10 minutes",
      description: '',
    },
    softener_notifications_5_text: {
      id: 'softener_notifications_5_text',
      defaultMessage: "Power break",
      description: '',
    },
    softener_device_notification: {
      id: 'softener_device_notification',
      defaultMessage: "Notification",
      description: '',
    },
    softener_device_alarm: {
      id: 'softener_device_alarm',
      defaultMessage: "Alarm",
      description: '',
    },
    superior_device_notification: {
      id: 'superior_device_notification',
      defaultMessage: "Notification",
      description: '',
    },
    superior_device_alarm: {
      id: 'superior_device_alarm',
      defaultMessage: "Alarm",
      description: '',
    },
    notifications_alerts_all: {
      id: 'notifications_alerts_all',
      defaultMessage: "All",
      description: '',
    },
    alerts_all: {
      id: 'alerts_all',
      defaultMessage: "Alerts",
      description: '',
    },
    notifications_all: {
      id: 'notifications_all',
      defaultMessage: "Notifications",
      description: '',
    },
    notifications_search_box: {
      id: 'notifications_search_box',
      defaultMessage: "Search",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/HistoryAlarms/Messages.js